function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { forwardRef, styled } from '@grupoboticario/flora-react-system';
var StyledContainer = styled('div', {
  boxSizing: 'border-box',
  flexShrink: 0,
  marginInline: 'auto',
  paddingInline: '$4',
  width: '100%',
  variants: {
    size: {
      small: {
        maxWidth: '420px'
      },
      medium: {
        maxWidth: '768px'
      },
      large: {
        maxWidth: '1200px'
      }
    },
    centerContent: {
      true: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }
    }
  }
});

/**
 * @component
 * @name Container
 * @description Container component
 * @tutorial https://flora.gb.tech/docs/components/core/container
 */
export var Container = forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(StyledContainer, _extends({
    ref: forwardedRef
  }, props));
});
//# sourceMappingURL=Container.js.map